/**
 * Client service for Construction Reports.
 * APPROVED_DPR, HINDRANCE_AGEING, OVERDUE_QUALITY, ATTENDANCE_PROVISIONAL, HANDOVER_INDEX.
 * R39 B7.a + B7.b (plan docs/plans/sector-operations.md row B7 :67).
 * Wraps callables via callable(); components never import firebase/*.
 */

import { callable } from './callable'
import type {
  GetConReportInput,
  ConReportResult,
} from '../types/ops'

export async function getConReport<
  TRow = Record<string, unknown>,
  TTotals = Record<string, unknown>,
>(
  input: GetConReportInput,
): Promise<ConReportResult<TRow, TTotals>> {
  return callable<GetConReportInput, ConReportResult<TRow, TTotals>>('getConReport', input)
}
